module.exports = __webpack_public_path__ + "static/media/Underworld.01a9bb96.jpg";